import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-p-1" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-black tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-white"
}
const _hoisted_5 = {
  key: 0,
  class: "tw-mt-4 tw-divide-y tw-divide-slate-200/70 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50"
}
const _hoisted_6 = { class: "tw-flex tw-items-start tw-justify-between tw-gap-3" }
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_8 = { class: "tw-text-xs tw-font-medium tw-text-slate-500" }
const _hoisted_9 = ["onClick", "disabled"]
const _hoisted_10 = ["onClick", "disabled"]
const _hoisted_11 = {
  key: 0,
  class: "tw-mt-2 tw-space-y-2"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["onClick", "disabled"]
const _hoisted_19 = {
  key: 1,
  class: "tw-mt-1.5 tw-text-sm tw-leading-6 tw-text-slate-800 tw-whitespace-pre-wrap"
}
const _hoisted_20 = {
  key: 1,
  class: "tw-mt-4 tw-text-sm tw-text-slate-500"
}
const _hoisted_21 = {
  key: 2,
  class: "tw-mt-4"
}
const _hoisted_22 = {
  key: 0,
  class: "tw-mt-3 tw-divide-y tw-divide-slate-200/70 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-slate-50/50"
}
const _hoisted_23 = { class: "tw-flex tw-items-start tw-justify-between tw-gap-3" }
const _hoisted_24 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_25 = { class: "tw-text-xs tw-font-medium tw-text-slate-500" }
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = { class: "tw-mt-1.5 tw-text-sm tw-leading-6 tw-text-slate-600 tw-whitespace-pre-wrap" }
const _hoisted_28 = { class: "tw-mt-5" }
const _hoisted_29 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-p-3 focus-within:tw-ring-2 focus-within:tw-ring-indigo-500/20" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "tw-mt-3 tw-flex tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_32 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "tw-mr-2",
  "uk-spinner": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Notes", -1)),
        (Array.isArray(_ctx.notes))
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.notes.length), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (Array.isArray(_ctx.notes) && _ctx.notes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: note.id || idx,
              class: "tw-p-3"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(note.date), 1),
                  (typeof note.isPublic === 'boolean')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold", note.isPublic ? 'tw-bg-emerald-100 tw-text-emerald-700' : 'tw-bg-slate-200 tw-text-slate-700'])
                      }, _toDisplayString(note.isPublic ? 'Printable' : 'Internal'), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.container || _ctx.order || _ctx.trip || _ctx.customer)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                        onClick: ($event: any) => (_ctx.startEditNote(note)),
                        disabled: _ctx.isUpdatingNote || _ctx.isArchivingNote
                      }, " Edit ", 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  (_ctx.container || _ctx.order || _ctx.trip || _ctx.customer)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-rose-200 tw-bg-rose-50 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-rose-700 hover:tw-bg-rose-100",
                        onClick: ($event: any) => (_ctx.archiveNote(note)),
                        disabled: _ctx.isUpdatingNote || _ctx.isArchivingNote
                      }, _toDisplayString(_ctx.isArchivingNote ? 'Archiving...' : 'Archive'), 9, _hoisted_10))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.editingNoteId === note.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingMessage) = $event)),
                      class: "tw-w-full tw-resize-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm tw-leading-6 tw-text-slate-900 focus:tw-outline-none",
                      rows: "4",
                      disabled: _ctx.isUpdatingNote
                    }, null, 8, _hoisted_12), [
                      [_vModelText, _ctx.editingMessage]
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.container || _ctx.order || _ctx.trip)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingIsPublic) = $event)),
                              type: "checkbox",
                              class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300",
                              disabled: _ctx.isUpdatingNote
                            }, null, 8, _hoisted_15), [
                              [_vModelCheckbox, _ctx.editingIsPublic]
                            ]),
                            _cache[8] || (_cache[8] = _createTextVNode(" Printable Note ", -1))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelEditNote && _ctx.cancelEditNote(...args))),
                          disabled: _ctx.isUpdatingNote
                        }, " Cancel ", 8, _hoisted_17),
                        _createElementVNode("button", {
                          type: "button",
                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60",
                          onClick: ($event: any) => (_ctx.saveEditedNote(note)),
                          disabled: !_ctx.editingMessage || _ctx.isUpdatingNote
                        }, _toDisplayString(_ctx.isUpdatingNote ? 'Saving...' : 'Save'), 9, _hoisted_18)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(note.message), 1))
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, "No notes yet.")),
    (_ctx.archivedNotes && _ctx.archivedNotes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-slate-600 hover:tw-bg-white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showArchived = !_ctx.showArchived))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.showArchived ? 'chevron-up' : 'chevron-down',
              class: "tw-h-3 tw-w-3"
            }, null, 8, ["icon"]),
            _createTextVNode(" Archived Notes (" + _toDisplayString(_ctx.archivedNotes.length) + ") ", 1)
          ]),
          (_ctx.showArchived)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.archivedNotes, (note, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: note.id || idx,
                    class: "tw-p-3 tw-opacity-70"
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(note.date), 1),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-slate-200 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-text-slate-600" }, " Archived ", -1))
                      ]),
                      (_ctx.container || _ctx.order || _ctx.trip || _ctx.customer)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                            onClick: ($event: any) => (_ctx.unarchiveNote(note)),
                            disabled: _ctx.isArchivingNote
                          }, " Unarchive ", 8, _hoisted_26))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(note.message), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
          class: "tw-w-full tw-resize-none tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-1 tw-py-1.5 tw-text-sm tw-leading-6 tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none",
          rows: "4",
          placeholder: "Add a note…",
          disabled: _ctx.isAddingNote
        }, null, 8, _hoisted_30), [
          [_vModelText, _ctx.message]
        ]),
        _createElementVNode("div", _hoisted_31, [
          (_ctx.container || _ctx.order || _ctx.trip)
            ? (_openBlock(), _createElementBlock("label", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isPublic) = $event)),
                  type: "checkbox",
                  class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300",
                  disabled: _ctx.isAddingNote
                }, null, 8, _hoisted_33), [
                  [_vModelCheckbox, _ctx.isPublic]
                ]),
                _cache[10] || (_cache[10] = _createTextVNode(" Printable Note ", -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-900/20 disabled:tw-cursor-not-allowed disabled:tw-opacity-60",
            type: "button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addNote && _ctx.addNote(...args))),
            disabled: !_ctx.message || _ctx.isAddingNote
          }, [
            (_ctx.isAddingNote)
              ? (_openBlock(), _createElementBlock("span", _hoisted_35))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.isAddingNote ? 'Adding...' : 'Add Note'), 1)
          ], 8, _hoisted_34)
        ])
      ])
    ])
  ]))
}